import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Newspaper } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InformacoesWidget() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/informacoes/publicadas`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="bg-white border-t border-slate-200 py-14" data-testid="informacoes-widget">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-8">
          <div className="text-xs uppercase tracking-wider text-[#00883A] font-bold mb-1 flex items-center gap-2">
            <Newspaper className="w-4 h-4" />Fique por dentro
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#0F172A]">Informação</h2>
          <div className="h-1 w-16 bg-[#083CA6] mt-3" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((info) => (
            <Card key={info.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-testid={`info-card-${info.id}`}>
              <img
                src={`${API}/informacoes/${info.id}/imagem`}
                alt="Informação"
                className="w-full aspect-square object-cover"
                loading="lazy"
              />
              <CardContent className="p-5">
                <p className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">
                  {info.texto}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
